import React from 'react';

/**
 * Placeholder component shown when no words are submitted
 */
const WordCloudPlaceholder = ({ containerSize }) => {
    return (
        <div
            className="word-cloud-wrapper-inner word-cloud-placeholder"
            style={{
                aspectRatio: '1',
                position: 'relative',
                margin: '0 auto',
            }}
        >
            <div className="word-cloud-empty">No words submitted yet.</div>
        </div>
    );
};

export default WordCloudPlaceholder;
